import WifiSVG from "@design-system/ui-icons/vanilla/Wifi"
import { createIcon } from "../createIcon"

export const WifiIcon = createIcon(WifiSVG)
